




























import { Vue, Component, Prop } from "vue-property-decorator";
import { Person } from "@/../generated/iloq-api";

@Component({
  components: {}
})
export default class PersonList extends Vue {
  @Prop(Array) persons!: Person[];
}
